import $ from 'jquery';

export default () => {

    $('.hamburger').on("click", function () {
        $('body').css('overflow', 'hidden');
        $(this).addClass('put-back');
        $('#offcanvasMenu').addClass('display');
        setTimeout(() => {
            $('.btn-x').removeClass('put-back');
        }, 100)
    });
    $('.btn-x').on("click", function () {
        $('body').css('overflow', 'auto');
        $(this).addClass('put-back');
        $('#offcanvasMenu').removeClass('display');
        setTimeout(() => {
            $('.hamburger').removeClass('put-back');
        }, 100)
    });


    $('.menu-parent-item').on('mouseover', function () {
        console.log('hover');
        $('.menu-parent-item').removeClass('active');
        $(this).addClass('active');
        $('.tab-pane').removeClass('active');
        var target = $(this).attr('data-bs-target');
        $(target).addClass('active');
    });

}


// WEBPACK FOOTER //
// ../views/partials/hamburger/hamburger.js